export default "__VITE_ASSET__B5G1qBbP__"